var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import color from 'color';
import classNames from 'classnames';
import React from 'react';
import styles from './StyledChip.module.css';
var StyledChip = /** @class */ (function (_super) {
    __extends(StyledChip, _super);
    function StyledChip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            e.stopPropagation();
            if (!_this.props.disabled && _this.props.onClick)
                _this.props.onClick(e);
        };
        _this.handleRemoveClick = function (e) {
            e.stopPropagation();
            if (!_this.props.disabled && _this.props.onRemove)
                _this.props.onRemove(e);
        };
        _this.handleKeyDown = function (e) {
            e.stopPropagation();
            if (!_this.props.disabled && _this.props.onRemove && e.key === 'Delete') {
                e.preventDefault();
                _this.props.onRemove(e);
            }
        };
        return _this;
    }
    StyledChip.prototype.render = function () {
        var _a, _b;
        var className = classNames(styles.chip, (_a = {},
            _a[styles.accented] = this.props.hasAccent,
            _a[styles.hasError] = this.props.hasError,
            _a[styles.disabled] = this.props.disabled,
            _a[styles.focusedChip] = this.props.focused,
            _a));
        var iconClass = classNames(styles.icon, (_b = {},
            _b[styles.iconAccented] = this.props.hasAccent,
            _b[styles.iconHasError] = this.props.hasError,
            _b[styles.focusedIcon] = this.props.focused,
            _b));
        var iconStyles = {
            backgroundColor: !!this.props.colour
                ? color(this.props.colour.toLowerCase()).lighten(0.5).hex()
                : undefined,
            color: !!this.props.colour ? 'white' : undefined
        };
        var chipStyles = {
            backgroundColor: this.props.colour,
            color: !!this.props.colour ? 'white' : undefined
        };
        var initialLabel = this.props.label || this.props.children || '';
        var shortLabel = this.props.maxLength && initialLabel.length > this.props.maxLength
            ? initialLabel.substring(0, this.props.maxLength) + '...'
            : initialLabel;
        return (React.createElement(Chip, { tabIndex: this.props.tabIndex, onClick: this.props.disabled ? undefined : this.props.onClick && this.handleClick, onDelete: this.props.disabled ? undefined : this.props.onRemove && this.handleRemoveClick, onKeyDown: this.props.disabled ? undefined : this.props.onRemove && this.handleKeyDown, "data-test-id": this.props.testId, deleteIcon: React.createElement(Icon, { classes: { root: iconClass }, style: iconStyles }, "close"), classes: {
                root: className
            }, icon: !!this.props.avatar ? this.props.avatar : undefined, style: chipStyles, label: shortLabel }));
    };
    StyledChip.muiName = 'chip';
    return StyledChip;
}(React.Component));
export { StyledChip };
